export enum SceneCompositionType {
    SCENE = 'scene',
    COSTFUNCTION = 'costFunction',
    CUSTOMCODE = 'customCode',
}
